import { render, staticRenderFns } from "./ProductInfoDialog.vue?vue&type=template&id=46b52526&"
import script from "./ProductInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInfoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports